import { Injectable } from '@angular/core';
import { PersistanceService } from './persistance.service';
import { State } from '../shared/types';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  private state: State = {
    results: {},
    config: {},
    studyFinished: false
  };

  constructor(private persistanceService: PersistanceService) {}

  getState() {
    return JSON.parse(JSON.stringify(this.state));
  }

  setState(value, key = undefined, commitFlag = false, studyFinished = false) {
    if (key === undefined) {
      this.state = value;
    } else {
      this.state[key] = value;
    }

    // commit the final results of a study to the backend
    if (studyFinished == true) {
      commitFlag = true;
      this.state.studyFinished = true;
      this.saveState(commitFlag, this.state.studyFinished);
    } else {
      this.saveState(commitFlag);
    }
  }

  private saveState(commit: boolean, studyFinished = false) {
    this.persistanceService.persistState(this.getState(), commit, studyFinished);
  }
}
